"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SingleStudents = void 0;
var _SingleStudents = require("./SingleStudents.styles");
var _hooks = require("../../../../../hooks");
var _AudiencePicker = require("../../../AudiencePicker.labels");
var _Modal = require("../../../../../Layout/Modal");
var _SelectedAudience = require("../SelectedAudience");
var _ExpandableButton = require("../../../../../UI/ExpandableButton");
var _Input = require("../../../../../UI/Input");
var _Tooltip = require("../../../../../UI/Tooltip");
var _Select = require("../../../../../UI/Select");
var _Icon = require("../../../../../UI/Icon");
var _Button = require("../../../../../UI/Button");
var _react = require("react");
var _AudienceSelectList = require("../AudienceSelectList");
var _urls = require("../../../../../utilities/urls");
var _jsxRuntime = require("react/jsx-runtime");
const SingleStudents = props => {
  const {
    createGroupTempData,
    setViewAndIndex,
    studentsSelectorTempData,
    setStudentsSelectorTempData,
    setCreateGroupTempData,
    readOnlyStudentsMapper,
    environmentID,
    classesIds,
    groupsIds,
    singleStudentsIds,
    classesMapper,
    groupsMapper,
    getStudentsSearchList,
    isEditMode = false,
    isConfirmEnabled = false,
    onConfirm,
    onCancel
  } = props;
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const styles = (0, _SingleStudents.useStyles)(props);
  const getLabel = (0, _hooks.useLabels)({
    labels: _AudiencePicker.labels
  });
  const [selectedOption, setSelectedOption] = (0, _react.useState)();
  const [options, setOptions] = (0, _react.useState)([]);
  const {
    role,
    schoolId: sessionSchoolId
  } = (0, _hooks.useSessionData)();
  const handleEditGroupName = () => {
    setCreateGroupTempData({
      ...createGroupTempData,
      newGroupName: createGroupTempData?.groupName
    });
    setViewAndIndex('createGroup', 2);
  };
  const handleSaveGroup = () => {
    if (studentsSelectorTempData && studentsSelectorTempData?.selectedStudentsIds?.length > 0) {
      setCreateGroupTempData({
        groupName: '',
        groupId: null
      });
      setViewAndIndex('studentsSelector', 1);
    }
  };
  const handleSearchInputChange = value => {
    setStudentsSelectorTempData({
      ...studentsSelectorTempData,
      studentsSearchText: value
    });
  };
  const handleSearchInputClear = () => {
    setStudentsSelectorTempData({
      ...studentsSelectorTempData,
      studentsSearchText: ''
    });
  };
  const handleSearchBtnClick = () => {
    setStudentsSelectorTempData({
      ...studentsSelectorTempData,
      isStudentsSearchOpen: !studentsSelectorTempData?.isStudentsSearchOpen
    });
  };
  const handleGroupsSelectChange = option => {
    setStudentsSelectorTempData({
      ...studentsSelectorTempData,
      selectedGroup: option.value.toString(),
      isGroupSearchOpen: false
    });
  };
  const handleStudentsSelectorTempDataChanged = newSelectData => {
    setStudentsSelectorTempData({
      ...studentsSelectorTempData,
      selectedStudentsIds: [...(newSelectData.selectedStudentsIds || [])]
    });
  };
  const handleGroupNotFoundClick = () => {
    window.open(`${_urls.userGroupManagementUrl}&SchoolID=${sessionSchoolId}&From=ofek`);
  };
  (0, _react.useEffect)(() => {
    let _options = [];
    if (environmentID) {
      _options.push({
        value: 'all',
        label: getLabel('studentsSelector_groupsSelect_all')
      });
    }
    classesIds?.forEach(id => {
      if (classesMapper && classesMapper[id]) {
        _options.push({
          value: id,
          label: classesMapper[id].group?.name
        });
      }
    });
    groupsIds?.forEach(id => {
      if (groupsMapper && groupsMapper[id]) {
        _options.push({
          value: id,
          label: groupsMapper[id].group?.name
        });
      }
    });
    if (environmentID && singleStudentsIds && singleStudentsIds.length > 0) {
      _options.push({
        value: 'singleStudents',
        label: getLabel('studentsSelector_groupsSelect_singleStudents')
      });
    }
    setOptions(_options);
    setSelectedOption(_options[0]);
  }, [classesIds, classesMapper, environmentID, getLabel, groupsIds, groupsMapper, singleStudentsIds]);
  (0, _react.useEffect)(() => {
    if (studentsSelectorTempData.selectedGroup) {
      const selected = options.filter(option => option.value === studentsSelectorTempData.selectedGroup);
      if (selected[0]) {
        setSelectedOption(selected[0]);
      }
    }
  }, [options, studentsSelectorTempData.selectedGroup]);
  const studentsList = getStudentsSearchList();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-AudiencePicker__full-item'],
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Header, {
      title: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [isEditMode ? createGroupTempData?.groupName + ' ' : getLabel('studentsSelector_offset_title'), isEditMode ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.Tooltip, {
          anchor: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
            view: "alternate",
            shape: "round",
            size: "small",
            onClick: handleEditGroupName,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
              name: "Pen",
              width: "16",
              height: "16"
            })
          }),
          children: getLabel('studentsSelector_edit_group_name_tooltip')
        }) : null]
      }),
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: styles['cc-AudiencePicker__single-students'],
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SelectedAudience.SelectedAudience, {
          ...props,
          audienceType: "students",
          onSelectedChanged: handleStudentsSelectorTempDataChanged,
          readOnlyStudentsMapper: studentsSelectorTempData && studentsSelectorTempData.selectedStudentsIds?.length > 0 ? readOnlyStudentsMapper : [],
          selectedGroupsIds: [],
          selectedClassesIds: [],
          selectedStudentsIds: studentsSelectorTempData?.selectedStudentsIds || []
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: styles['cc-AudiencePicker__single-students__header'],
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            children: [!isMobileView && !studentsSelectorTempData?.isStudentsSearchOpen && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: styles['cc-AudiencePicker__single-students__header__select-title'],
              children: getLabel('studentsSelector_groupsSelect_title')
            }), !studentsSelectorTempData?.isStudentsSearchOpen && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: styles['cc-AudiencePicker__single-students__header'],
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Select.Select, {
                id: "groupSelection",
                btnProps: {
                  view: 'outlined',
                  color: 'basic'
                },
                options: options,
                isFullScreen: true,
                isWithFilter: true,
                filterPlaceholder: getLabel('studentsSelector_groupsSelectPlaceholder'),
                value: selectedOption,
                onChange: handleGroupsSelectChange
              }), role?.toLowerCase() === 'teacher' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
                id: "GroupNotFoundButton",
                size: "small",
                view: "alternate",
                color: "primary",
                shape: "roundedRectangle",
                category: "assignActivity",
                label: "groupNotFound",
                onClick: handleGroupNotFoundClick,
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
                  children: getLabel('groupsSelectListTools_groupNotFound')
                })
              })]
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: styles['cc-AudiencePicker__single-students__header__search'],
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ExpandableButton.ExpandableButton, {
              isOpen: studentsSelectorTempData?.isStudentsSearchOpen,
              isWithTransition: true,
              btnIconName: studentsSelectorTempData?.isStudentsSearchOpen ? 'ArrowBack' : 'Search',
              btnTooltip: getLabel('studentsSelector_studentsSearchPlaceholder'),
              btnProps: {
                onClick: handleSearchBtnClick,
                id: 'studentSearch',
                category: 'assignActivity',
                label: studentsSelectorTempData?.isStudentsSearchOpen ? 'backSearchStudentName' : 'searchStudentName'
              },
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Input.Input, {
                id: "searchByStudentName",
                type: "text",
                view: "none",
                value: studentsSelectorTempData?.studentsSearchText,
                placeholder: getLabel('studentsSelector_studentsSearchPlaceholder'),
                ariaLabel: getLabel('studentsSelector_studentsSearchPlaceholder'),
                width: "100%",
                onChange: handleSearchInputChange,
                isWithClearButton: Boolean(studentsSelectorTempData?.studentsSearchText),
                onClearButtonClick: handleSearchInputClear
              })
            })
          })]
        })]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Content, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_AudienceSelectList.AudienceSelectList, {
        ...props,
        audienceType: "students",
        searchedStudentsData: studentsList[0] && typeof studentsList[0] === 'string' ? null : studentsList,
        onSelectedChanged: handleStudentsSelectorTempDataChanged,
        studentsIds: studentsList[0] && typeof studentsList[0] === 'string' ? studentsList : studentsList.map(student => student.id),
        readOnlyStudentsMapper: studentsSelectorTempData?.selectedStudentsIds && studentsSelectorTempData.selectedStudentsIds.length > 0 ? readOnlyStudentsMapper : [],
        selectedGroupsIds: [],
        selectedClassesIds: [],
        selectedStudentsIds: studentsSelectorTempData?.selectedStudentsIds || []
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal.Modal.Footer, {
      justifyContent: "space-between",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Footer.Section, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
          view: "link",
          id: "backButton",
          onClick: onCancel,
          children: getLabel('back')
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal.Modal.Footer.Section, {
        children: [!isEditMode && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
          onClick: handleSaveGroup,
          id: "saveNewGroupButton",
          view: "outlined",
          isDisabled: studentsSelectorTempData?.selectedStudentsIds.length === 0,
          category: "assignActivity",
          label: "saveNewGroup",
          children: getLabel('save_as_group')
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
          onClick: onConfirm,
          isDisabled: !isConfirmEnabled,
          id: "confirmButton",
          category: "assignActivity",
          label: "confirmSingleStudents",
          children: getLabel('confirm')
        })]
      })]
    })]
  });
};
exports.SingleStudents = SingleStudents;